module.exports = __webpack_public_path__ + "img/icon_map_36_off_100.67fc3010.png";